var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8V22C0 26.4183 3.58172 30 8 30H22C26.4183 30 30 26.4183 30 22V8C30 3.58172 26.4183 0 22 0H8ZM22.8694 8.00614C22.946 7.99795 23.0233 7.99795 23.1 8.00614L14.9494 16.4433L6.82123 8.05279C6.91813 8.02344 7.01841 8.00775 7.11935 8.00614H22.8694ZM15.7425 17.2712L23.9325 8.81662C23.9727 8.93081 23.9955 9.05082 24 9.1723V20.8338C24 21.1431 23.8815 21.4397 23.6705 21.6584C23.4595 21.8771 23.1734 22 22.875 22H7.125C6.82663 22 6.54048 21.8771 6.3295 21.6584C6.11853 21.4397 6 21.1431 6 20.8338V9.1723C6.00119 9.07379 6.01442 8.97583 6.03937 8.88076L14.1562 17.2712C14.367 17.4884 14.6522 17.6104 14.9494 17.6104C15.2466 17.6104 15.5317 17.4884 15.7425 17.2712ZM7.11375 20.8338H7.89563L11.9963 16.6182L11.2031 15.7961L7.11375 20V20.8338ZM22.0763 20.8338H22.8638L22.8581 20L18.7687 15.7961L17.9756 16.6182L22.0763 20.8338Z",
    fill: "#593012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.97411277a319793c396876676f34905a.svg";
export { ForwardRef as ReactComponent };